import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import PurOrdDivisionActions, { PurOrdDivisionTypes } from '../Stores/PurOrdDivision/Actions';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';

const getAppStore = state => state.app;

// eslint-disable-next-line import/prefer-default-export

export function* purOrdDivisionUpdateSyncSetting({ settings }) {
  try {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      settings,
      division_id: app.curDivisionId
    };
    const result = yield call(
      ApiService.postApi,
      app.apiUrl,
      `purOdr/update-sync-setting`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(false));
  }
}

export function* purOrdDivisionSyncPurOrd() {
  try {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      division_id: app.curDivisionId
    };
    const result = yield call(ApiService.postApi, app.apiUrl, `purOdr/import`, app.token, postData);

    if (result.isSuccess === true) {
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(false));
  }
}

export function* purOrdDivisionFetchList() {
  try {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(true));

    const app = yield select(getAppStore);
    const result = yield call(
      ApiService.getApi,
      app.apiUrl,
      `purOdr/division-mapping/${app.curDivisionId}`,
      app.token,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      yield put(PurOrdDivisionActions.purOrdDivisionFetchListSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(false));
  }
}

export function* purOrdDivisionCreateDivisionMap({ form }) {
  try {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(true));
    const app = yield select(getAppStore);
    const postData = { data: form, division_id: app.curDivisionId };
    const result = yield call(
      ApiService.postApi,
      app.apiUrl,
      `purOdr/create-division-mapping`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PurOrdDivisionActions.purOrdDivisionFetchListSuccess(result.data));
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(false));
  }
}

export function* purOrdDivisionUpdateDivisionMap({ id, form }) {
  try {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(true));
    const app = yield select(getAppStore);
    const postData = { id, data: form };
    const result = yield call(
      ApiService.postApi,
      app.apiUrl,
      `purOdr/update-division-mapping`,
      app.token,
      postData
    );
    if (result.isSuccess === true) {
      yield put(PurOrdDivisionActions.purOrdDivisionFetchListSuccess(result.data));
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PurOrdDivisionActions.purOrdDivisionFetchListLoading(false));
  }
}

export const saga = [
  takeLatest(
    PurOrdDivisionTypes.PUR_ORD_DIVISION_UPDATE_SYNC_SETTING,
    purOrdDivisionUpdateSyncSetting
  ),
  takeLatest(PurOrdDivisionTypes.PUR_ORD_DIVISION_SYNC_PUR_ORD, purOrdDivisionSyncPurOrd),
  takeLatest(PurOrdDivisionTypes.PUR_ORD_DIVISION_FETCH_LIST, purOrdDivisionFetchList),
  takeLatest(
    PurOrdDivisionTypes.PUR_ORD_DIVISION_CREATE_DIVISION_MAP,
    purOrdDivisionCreateDivisionMap
  ),
  takeLatest(
    PurOrdDivisionTypes.PUR_ORD_DIVISION_UPDATE_DIVISION_MAP,
    purOrdDivisionUpdateDivisionMap
  )
];
